













import {Component, Vue} from 'vue-property-decorator';
import axios from 'axios';

import Graph from '@/components/Namespace.vue';
import Network from '@/components/Network.vue';
import Network2 from '@/components/Network2.vue';

// import SearchField from '@/components/SearchField.vue';

@Component({
    components: {
        Network2,
        Network,
        Graph,
        // SearchField,
    },
})
export default class Home extends Vue {

    private jsonData: any = {};

    public async refreshNamespace(ns: string) {
        const url = new URL(Vue.prototype.appConfig.adminusUrl + 'json/' + ns);
        this.jsonData = await axios(url.href);
    }

    private async mounted() {
        const url = new URL(Vue.prototype.appConfig.adminusUrl + 'json/blackbeard2');
        this.jsonData = await axios(url.href);
    }

}
